/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * ----------------------------------------------------------------------------
 * Announcement bar
 * ----------------------------------------------------------------------------
 */


function getMaxHeight({
    elems
}) {
    let maxHeight = 0;

    if (!elems) return 0;

    elems.forEach((elem) => {
        const height = elem.offsetHeight;
        console.log(`height: `, height);
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    return maxHeight;
}

const announcementBarWrapper = document.querySelector('[data-section-type="announcement-bar"] .AnnouncementBar__Wrapper');
if (announcementBarWrapper) {
    const barElems = announcementBarWrapper.querySelectorAll('.AnnouncementBar__Content');
    const barElemsInner = announcementBarWrapper.querySelectorAll('.AnnouncementBar__Content-inner');
    const sliderTime = document.querySelector('[data-section-type="announcement-bar"]').hasAttribute('data-sliderTime') ? document.querySelector('[data-section-type="announcement-bar"]').dataset.sliderTime * 1000 : 5000;

    if (1 < barElems.length) {
        let lastActive,
            currentActive,
            counter = 0,
            activeSlider = false;

        const setActive = (position) => {
            if (currentActive) {
                lastActive = currentActive;
                lastActive.classList.add('last-active');
                currentActive.classList.remove('active');

                setTimeout(() => {
                    if (lastActive) {
                        lastActive.classList.remove('last-active');
                    }
                }, 700);
            }

            barElems[position].classList.add('active');
            currentActive = barElems[position];

            if (counter < barElems.length - 1) {
                counter = ++counter;
            } else {
                counter = 0;
            }
        };

        let interval = setInterval(() => {
            setActive(counter);
        }, sliderTime);
        const stopinterval = () => {
            clearInterval(interval);
        };

        window.addEventListener('resize', function() {
            if (window.matchMedia('(max-width: 641px)').matches) {
                const maxHeight = getMaxHeight({
                    elems: barElemsInner
                });
                announcementBarWrapper.style.height = `${ maxHeight }px`;

                if (!activeSlider) {
                    activeSlider = true;
                    interval = setInterval(() => {
                        setActive(counter);
                    }, sliderTime);
                }
            } else {
                activeSlider = false;
                announcementBarWrapper.style.height = `auto`;
                stopinterval();
            }
        });

        if (barElems) {
            if (window.matchMedia('(max-width: 641px)').matches) {
                activeSlider = true;
                setActive(counter);
            } else {
                activeSlider = false;
                stopinterval();
            }
        }

        if (window.matchMedia('(max-width: 641px)').matches) {
            const maxHeight = getMaxHeight({
                elems: barElemsInner
            });
            announcementBarWrapper.style.height = `${ maxHeight }px`;
        }
    }
}

/**
 * ----------------------------------------------------------------------------
 * Page Content - Popup
 * ----------------------------------------------------------------------------
 */


class PageContentPopup {
    constructor({ url }) {
        this.dom = {}
        this.settings = {
            url: url,
        };

        /**
         * When te content is fetched, the popup get initialized
         */
        document.body.classList.add('loading');
        this.getContent();
    }

    getContent() {
        fetch(this.settings.url, { mode: 'cors' }).then((response) => {
            return response.text();
        }).then((content) => {
            this.settings.content = content
            this.init();
        }).catch(() => {
            document.body.classList.remove('loading');
        })
    }

    init() {
        /**
         * Create the popup
         */
        this.dom.popup = this.returnHtml();

        /**
         * attach eventlisteners to the popup, ex, close button
         */
        this.addEventListeners();


        /**
         * Adding the popup to the dom
         */
        document.body.appendChild(this.dom.popup);

        /**
         * Setting a short timeout so the open animation works properly
         */
        setTimeout(() => {
            this.open();
            document.body.classList.remove('loading');
        }, 20);
    }



    returnHtml() {
        const htmlString = `
        <aside class="light-modal">
            <div class="light-modal__overlay" data-close></div>
                <div class="light-modal__container">
                    <button class="light-modal__close" data-close>
                        <svg class="Icon Icon--close " role="presentation" viewBox="0 0 16 14">
                            <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
                        </svg>
                    </button>
                    <div class="light-modal__inner">
                    ${ this.settings.content }
                    </div>
                </div>
            </div>
        </aside>`;

        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        return div.firstChild;
    }

    addEventListeners() {
        this.dom.closeElems = this.dom.popup.querySelectorAll('[data-close]');
        if (!this.dom.closeElems) return;

        this.dom.closeElems.forEach(closeButtom => {
            closeButtom.addEventListener('click', () => {
                this.close();
            });
        });
    }

    open() {
        this.dom.popup.classList.add('open');
        window.scrollLock.disablePageScroll();
    }

    close() {
        this.dom.popup.classList.remove('open');
        window.scrollLock.enablePageScroll();
    }
}

const pageContentPupupButtons = document.querySelectorAll(
    '.js-page-content-popup'
);

pageContentPupupButtons.forEach((pageContentPupupButton) => {
    const url = pageContentPupupButton.hasAttribute('data-url') ? pageContentPupupButton.dataset.url : null;

    if (!url) {
        pageContentPupupButton.remove();
        return;
    }

    let popup = null;

    pageContentPupupButton.classList.remove('js-page-content-popup');

    pageContentPupupButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (popup === null) {
            popup = new PageContentPopup({ url });
        } else {
            popup.open();
        }
    });
});

/**
* ----------------------------------------------------------------------------
* Custom filter string
* ----------------------------------------------------------------------------
*/

{

    let storedProductSkusInSession = JSON.parse(sessionStorage.getItem("productSkus"));

    let globalFilterKeywords = [];
    let globalFilterKeywordsInit = false;

    class CustomfilterKeyword {
        constructor(elem, index, keepGlobalFilterKeywords) {

            this.dom = {
                main: elem,
                input: elem.querySelector('.js--keyword'),
                counter: elem.querySelector('.js--count')
            }
            this.options = {
                keepIndex: keepGlobalFilterKeywords
            }

            this.dom.main.classList.add('is-init')
            this.index = index
            this.init();
        }

        init() {
            this.eventlisteners();

            setTimeout(() => {
                this.dom.input.classList.add('animate');
            }, 100);

        }

        eventlisteners() {
            this.dom.input.addEventListener('click', (e) => {
                e.stopPropagation();

                this.setChecked();
                this.verify();
            });

            document.addEventListener('allCustomfilterKeyword:init', () => {
                this.setCheckedByUrl();
            }, {
                once: true,
            })

            this.addCounter();
            // if (storedProductSkusInSession && JSON.stringify(storedProductSkusInSession) !== '{}') {
            //     // this.addCounter();
            // }
            // else {
            //     document.addEventListener('ColorSwatchesData:saved', () => {
            //         storedProductSkusInSession = JSON.parse(sessionStorage.getItem("productSkus"));
            //         // this.addCounter();
            //     }, {
            //         once: true,
            //     })
            // }
        }


        addCounter() {
            let totalCount = 0;

             document.querySelectorAll('.js--list').forEach(element => {

                if (element.value.includes(this.dom.input.value)) {   
                    if (element.hasAttribute('data-count')) {
                        totalCount += Number(element.getAttribute('data-count'))
                    }
                }
            });

            this.dom.counter.innerText = `(${ totalCount })`;
        }

        setCheckedByUrl() {
            const url = new URL(window.location.href);
            const urlParams = new URLSearchParams(url.search);
            const _this = this;

            if (urlParams) {
                for (var value of urlParams.values()) {
                    if (value === _this.dom.input.value) {
                        _this.dom.input.checked = true
                        this.setChecked();
                    }
                }
            }
        }

        setChecked() {
            if (globalFilterKeywordsInit) {
                let matchingKeys = globalFilterKeywords.filter(x => x.dom.input.value == this.dom.input.value);
                matchingKeys.forEach(matchingKey => {
                    matchingKey.dom.input.checked = this.dom.input.checked
                });
            }
        }


        verify() {

            let arrayOfCheckedItems = [];

            // Create an array of checked items.

            globalFilterKeywords.forEach(opt => {
                if (opt.dom.input.checked) {
                    arrayOfCheckedItems.push(opt);
                }
            });

            // Loop through all the hidden fields and if any keyword from the
            // arrayOfCheckedItems exists in the hidden field value, check the
            // field.
            let hiddenFields = document.querySelectorAll('input[name="' + this.dom.input.name + '"].js--list');
            hiddenFields.forEach(opt => {

                if (arrayOfCheckedItems.some(k => opt.value.includes(k.dom.input.value))) {
                    opt.checked = true;
                } else {
                    opt.checked = false;
                }
            });
        }
    }


    const initCustomFilter = ({ keepGlobalFilterKeywords = false }) => {

        const filterKeywords = document.querySelectorAll('.js--custom_filter:not(.is-init)');
        filterKeywords.forEach((keyword, index) => {
            const filterKeyword = new CustomfilterKeyword(keyword, index, keepGlobalFilterKeywords);
            if (keepGlobalFilterKeywords === false) {
                globalFilterKeywords.push(filterKeyword);
            }
        });

        globalFilterKeywordsInit = true;
        document.dispatchEvent(new CustomEvent('allCustomfilterKeyword:init'));
    }

    initCustomFilter({});

    document.addEventListener('filter:reloaded', () => {
        initCustomFilter({ keepGlobalFilterKeywords: true });
    })
}